import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/firestore";
import "firebase/storage";
import "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBPxZIi6Gv0BLzIPPrmoM0OBd_WdeCyS7o",
  authDomain: "jazzudesigner-sg.firebaseapp.com",
  projectId: "jazzudesigner-sg",
  storageBucket: "jazzudesigner-sg.appspot.com",
  messagingSenderId: "764365820802",
  appId: "1:764365820802:web:54b6cb6eb3a523fa2b759b"
};


firebase.initializeApp(firebaseConfig);

export const storage = firebase.storage();
export const firestore = firebase.firestore()
export const auth = firebase.auth();
//export const cloudFuntions = firebase.functions();
export const cloudFunctions = firebase.app().functions('asia-southeast2');
if (process.env.NODE_ENV === 'development') {
  cloudFunctions.useFunctionsEmulator('http://localhost:5001');
}
export default firebase;
